import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intersection } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { modules } from 'configs/index.js';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Navigation from 'components/Navigation';
// import CompanySelectWin from 'containers/App/components/CompanySelectWin/';
import Progress from 'components/Progress';
import {
  switchLocale,
} from 'containers/App/reducers/applicationReducer';
import {
  functions,
} from 'configs';
import {
  logout,
} from 'containers/App/reducers/userReducer';
import {
  toggleOnboardingProcess,
} from 'containers/App/reducers/applicationReducer';
import {
  setMessage,
  resetMessage,
} from 'containers/App/reducers/messageReducer';
import PendingPage from '../PendingPage';
import { SideMenu } from '@mayo/xe-ui-kit';

const mapStateToProps = (state) => {
  const { app, leaveWarn } = state;
  const { functionSetting, isShowOnboardingProcess } = app.application;
  const { userRole } = app.user;
  return {
    application: app.application,
    user: app.user,
    leaveWarnHandler: leaveWarn.handler,
    isShowPeopleSearch: (functionSetting.datas.find(v => v.functionCode === functions.peopleSearch) || {}).enable,
    isShowOnboardingProcess: isShowOnboardingProcess && intersection(userRole, functions.standardProcessesByRoles).length > 0,
    isShowMAYOForm: (functionSetting.datas.find(v => v.functionCode === functions.mayoForm) || {}).enable,
    displayCommonProcessesGuideSwitch: intersection(userRole, functions.standardProcessesByRoles).length > 0,
  };
};
const dispatchProps = {
  switchLocale,
  setMessage,
  resetMessage,
  toggleOnboardingProcess,
};

class Layout extends Component {
  static get propTypes() {
    return {
      application: PropTypes.shape({
        isLoggedIn: PropTypes.bool,
        locale: PropTypes.string,
        locales: PropTypes.array,
        progresses: PropTypes.array,
        companyLogoUrl: PropTypes.string,
      }).isRequired,
      user: PropTypes.shape({
        userDisplayName: PropTypes.string,
        allowModules: PropTypes.array,
        userPermission: PropTypes.array,
        isPermissionLoaded: PropTypes.bool,
        functionRole: PropTypes.object,
        isVerify: PropTypes.bool,
        isLoaded: PropTypes.bool,
      }).isRequired,
      history: PropTypes.object.isRequired,
      switchLocale: PropTypes.func.isRequired,
      children: PropTypes.node,
      main: PropTypes.node,
      sidebar: PropTypes.node,
      leaveWarnHandler: PropTypes.func,
      isShowPeopleSearch: PropTypes.bool,
      isShowOnboardingProcess: PropTypes.bool,
      isShowMAYOForm: PropTypes.bool,
      displayCommonProcessesGuideSwitch: PropTypes.bool,
      toggleOnboardingProcess: PropTypes.func,
      setMessage: PropTypes.func,
      resetMessage: PropTypes.func,
    };
  }

  constructor() {
    super();
    // this.state = {
    //   isCompanySelectWinShow: false,
    // };
    // this.handleCompanySelectWinShow = this.handleCompanySelectWinShow.bind(this);
    // this.handleCompanyItemClick = this.handleCompanyItemClick.bind(this);
    this.handleSwitchLocale = this.handleSwitchLocale.bind(this);
    this.handleLeaveWarn = this.handleLeaveWarn.bind(this);
    this.renderMainContent = this.renderMainContent.bind(this);
  }

  // handleCompanySelectWinShow() {
  //   this.setState({ isCompanySelectWinShow: true });
  // }
  // TODO company select
  // handleCompanyItemClick() {}

  handleSwitchLocale(locale) {
    this.props.switchLocale(locale);
  }

  handleLeaveWarn(event) {
    if (this.props.leaveWarnHandler) {
      const nextpath = event.target.pathname || event.target.parentElement.pathname;
      this.props.leaveWarnHandler(() => {
        window.location.href = nextpath;
      });
      event.preventDefault();
    }
  }

  // renderCompanySelectWin() {
  //   return (
  //     <CompanySelectWin
  //       datas={datas}
  //       onCompanyItemClick={this.handleCompanyItemClick}
  //       onClose={() => this.setState({ isCompanySelectWinShow: false })}
  //     />
  //   );
  // }

  clearLocalStorageExcept(keysToKeep) {
    for (let i = window.localStorage.length - 1; i >= 0; i--) {
      const key = window.localStorage.key(i);
      // 检查当前键是否需要保留
      if (!keysToKeep.includes(key)) {
        // 如果不需要保留，删除该键值对
        window.localStorage.removeItem(key);
      }
    }
  }

  renderPreviewContent({ main, sidebar } = {}) {
    return (
      <div className="hn-preview">
        {sidebar}
        {main}
      </div>
    );
  }
  renderMainContent({ main, sidebar, application, user, history } = {}) {
    const isLoggedInLoaded = application.isLoggedIn && application.isLoaded && user.isLoaded && user.isVerify;
    const { displayCommonProcessesGuideSwitch, isShowOnboardingProcess, isShowMAYOForm } = this.props;
    return (
      <div>
        {/* foundation 1.7 9.5 待需求再開時加回 */}
        {/* state.isCompanySelectWinShow && this.renderCompanySelectWin() */}
        <Header
          companyLogo={application.companyLogoUrl}
          isLoggedIn={isLoggedInLoaded}
          history={history}
          userName={user.userDisplayName}
          onLogout={() => {
            if (this.props.leaveWarnHandler) {
              return this.props.leaveWarnHandler(logout);
            }
            const keysToKeep = ['refreshDate', 'locale'];
            this.clearLocalStorageExcept(keysToKeep);
            return logout();
          }}
          // onCompanySelect={this.handleCompanySelectWinShow}
          onLinkClick={this.handleLeaveWarn}
          isShowPeopleSearch={this.props.isShowPeopleSearch}
          displayCommonProcessesGuideSwitch={displayCommonProcessesGuideSwitch}
        />
        <Navigation
          isLoggedIn={isLoggedInLoaded}
          modules={modules}
          allowModules={user.allowModules}
          userPermission={user.userPermission}
          isPermissionLoaded={user.isPermissionLoaded}
          isAdmin={user.functionRole.isUltimateAdministrator}
          onNavigationItemClick={this.handleLeaveWarn}
          filterModule={(moduleName) => {
            if (moduleName === 'MAYOForm') {
              return !isShowMAYOForm;
            }
            // 已有舊招募模組(RMS)的人繼續用 Recruitment，不顯示新招募站台
            if (moduleName === 'JobHub') {
              return (user.allowModules || []).indexOf('RMS') !== -1;
            }
            return false;
          }}
        />
        {isShowOnboardingProcess && (
          <SideMenu
            onClose={() => {
              this.props.setMessage(
                [<FormattedMessage
                  key="1"
                  id="SH_Message"
                  defaultMessage="訊息"
                />],
                [<FormattedMessage id="SH_UseGuideOnAlready" defaultMessage="功能已開啟，將關閉常用流程引導" />],
                () => {
                  this.props.toggleOnboardingProcess({
                    enable: false,
                  });
                  this.props.resetMessage();
                },
                this.props.resetMessage,
                '#008BCD',
                this.props.resetMessage
                );
            }}
          />
        )}
        <div className="main-container">
          <div className="width-sys">
            {sidebar}
            {main}
          </div>
        </div>
        <Footer
          locale={application.locale}
          locales={application.locales}
          onSwitchLocale={this.handleSwitchLocale}
          leaveWarnHandler={this.props.leaveWarnHandler}
        />
      </div>
    );
  }

  render() {
    const { props } = this;
    const {
      application,
      user,
      history,
    } = props;
    const { isPreviewMode } = application;
    let main = props.main;
    const sidebar = props.sidebar;
    if (!sidebar) {
      main = props.children;
    }

    return (
      <div>
        {
          application.progresses.map((progress) => {
            return <Progress progress={progress.progress} key={progress.key} color={progress.color}/>;
          })
        }
        {
          (() => {
            if (!application.isLoaded && !isPreviewMode) {
              return <PendingPage />;
            }

            return (isPreviewMode)
            ? this.renderPreviewContent({ main, sidebar })
            : this.renderMainContent({ main, sidebar, application, user, history });
          })()
        }
      </div>
    );
  }
}

export default connect(mapStateToProps, dispatchProps)(Layout);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/components/Layout/index.js
 **/